import { createSelector } from "reselect";
import searchLayersSelector from "./searchLayersSelector";
import sequenceLengthSelector from "./sequenceLengthSelector";
import { getComplementSequenceString } from "@teselagen/sequence-utils";
function searchMutationFeaturesSelector(searchLayers, findTool, sequenceLength) {
  const { matchNumber, highlightAll, isOpen, searchText, mismatchesAllowed } = findTool || {};
  if (!isOpen || !searchText || mismatchesAllowed === 0) return {};
  const activeSearchLayers = highlightAll ? searchLayers : searchLayers[matchNumber] ? [searchLayers[matchNumber]] : [];
  const features = {};
  activeSearchLayers.forEach((layer, i) => {
    if (layer?.mismatchPositions?.length) {
      layer.mismatchPositions.forEach((posOffset, j) => {
        const queryBase = searchText[posOffset];
        let subjectBase;
        if (layer.forward) {
          subjectBase = layer.matchedString[posOffset];
        } else {
          const posOffsetInMatch = searchText.length - 1 - posOffset;
          const topStrandBase = layer.matchedString[posOffsetInMatch];
          subjectBase = getComplementSequenceString(topStrandBase);
        }
        const offsetToUse = layer.forward ? posOffset : searchText.length - 1 - posOffset;
        const absolutePos = (layer.start + offsetToUse) % sequenceLength;
        const id = `search_mutation_${i}_${j}_${absolutePos}`;
        features[id] = {
          id,
          name: `search_mutation (${queryBase}>${subjectBase})`,
          type: "search_mutation",
          start: absolutePos,
          end: absolutePos,
          forward: !!layer.forward,
          isTemporary: true
        };
      });
    }
  });
  return features;
}
export default createSelector(
  searchLayersSelector,
  (state) => state.findTool,
  sequenceLengthSelector,
  searchMutationFeaturesSelector
);
